// en-EN locale is bundled by default
import i18n from "../webix/i18n";

// germany
import de from "./de";
i18n.locales["de-DE"] = de;

// spain
import es from "./es";
i18n.locales["es-ES"] = es;

// france
import fr from "./fr";
i18n.locales["fr-FR"] = fr;

// italy
import it from "./it";
i18n.locales["it-IT"] = it;

// japan
import ja from "./ja";
i18n.locales["ja-JP"] = ja;

// portuguese
import pt from "./pt";
i18n.locales["pt-BR"] = pt;

// chinese
import zh from "./zh";
i18n.locales["zh-CN"] = zh;

// russian
import ru from "./ru";
i18n.locales["ru-RU"] = ru;

// belarus
import be from "./be";
i18n.locales["be-BY"] = be;